import { AppStore } from './lib/store/AppStore';
export { AppStore } from './lib/store/AppStore';

// --

export const store = new AppStore(void 0, { trackError: true });